module.exports = __webpack_public_path__ + "static/img/pay-bg.34b7fe00.png";